import AudioPlayer from '../../common/audio/main';


export default class ScrStart{

    constructor(){
        this._init();
    }

    render(callback){
        this.callback = callback;
        document.querySelector('.scr-start').classList.add('-active');

        setTimeout(()=>{
            this._playAudio();
        }, 1000);
    }

    _init(){
        const ext = window.navigator.userAgent.match(/Android/) ? ".ogg" : ".mp3"; 
        this.soundAssets = {
            na1: { src:[`./assets/audio/start/na1${ext}`] },
            na2: { src:[`./assets/audio/start/na2${ext}`] },
            na3: { src:[`./assets/audio/start/na3${ext}`] },
        }
    }

    _playAudio(){
        const sound = new AudioPlayer(this.soundAssets);
        sound.load()
            .then(() => {

                sound.playSequence(['na1', 'na2', 'na3'], ()=>{

                    setTimeout(()=>{
                        document.querySelector('.js-scr-title').classList.remove('-active');
                        this.callback();
                    }, 500)
                });
                
                sound.setOnSequenceOneStart(key=>{

                    if(key==='na3'){
                        const $tutorial = document.querySelector('.js-tutorial');
                        $tutorial.querySelector('img').setAttribute('src', `./assets/img/start/tutorial.gif?${new Date().getTime()}`);
                        $tutorial.classList.add('-active');
                    }
                });
            })
            .catch((err) => {});
    }
}